const initialState = {
  rewardList: null,
  reward: {},
  redeemRewardInfo: {},
};

const rewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_REWARD_GROUPS": {
      return {
        ...state,
        rewardList: action.payload,
      };
    }
    case "SET_REWARD": {
      return {
        ...state,
        reward: action.payload,
      };
    }
    case "RESET_REWARD": {
      return {
        ...state,
        reward: {},
      };
    }
    case "SET_REWARD_INFO": {
      return {
        ...state,
        reward: {
          ...state.reward,
          [action.payload.key]: action.payload.value,
        },
      };
    }
    case "SET_REDEEM_REWARD_INFO": {
      return {
        ...state,
        redeemRewardInfo: action.payload,
        message: "",
        showGetRewardButton: true,
      };
    }
    case "SET_REWARD_CODE": {
      return {
        ...state,
        reward: action.payload,
        showGetRewardButton: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default rewardReducer;
